import React, { useState, useEffect } from 'react'
import { Container, Left, Right, Badge } from './style'
import { COLORS } from '../../theme'

const InstituteToggle = ({
  value,
  onChange,
  disabled = false,
  hasInstitute = true,
  hasCorporate = true,
  instituteCount = 0,
  corporateCount = 0,
}) => {
  const [current, setCurrent] = useState(value)

  useEffect(() => {
    setCurrent(value)
  }, [value])

  const handleClick = (selectedValue) => {
    if (disabled) return
    setCurrent(selectedValue)
    onChange(selectedValue)
  }

  // If only one option is available, don't show the toggle
  if (!hasInstitute && !hasCorporate) return null
  if (!hasInstitute && hasCorporate) return null
  if (hasInstitute && !hasCorporate) return null

  return (
    <Container disabled={disabled}>
      {hasInstitute && (
        <Left
          color={current === 'institute' ? COLORS.PRIMARY : COLORS.GREY_T_80}
          background={current === 'institute' ? COLORS.BLUE_T_92 : COLORS.WHITE}
          onClick={() => handleClick('institute')}
          disabled={disabled}
        >
          Institute
          {instituteCount > 0 && (
            <Badge
              background={
                current === 'institute' ? COLORS.PRIMARY : COLORS.GREY_T_90
              }
              color={current === 'institute' ? COLORS.WHITE : COLORS.GREY_T_60}
            >
              {instituteCount}
            </Badge>
          )}
        </Left>
      )}
      {hasCorporate && (
        <Right
          color={current === 'corporate' ? COLORS.PRIMARY : COLORS.GREY_T_80}
          background={current === 'corporate' ? COLORS.BLUE_T_92 : COLORS.WHITE}
          onClick={() => handleClick('corporate')}
          disabled={disabled}
        >
          Corporate
          {corporateCount > 0 && (
            <Badge
              background={
                current === 'corporate' ? COLORS.PRIMARY : COLORS.GREY_T_90
              }
              color={current === 'corporate' ? COLORS.WHITE : COLORS.GREY_T_60}
            >
              {corporateCount}
            </Badge>
          )}
        </Right>
      )}
    </Container>
  )
}

export default InstituteToggle